<template>
  <div>
    <div class="content-heading">
        <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/module-plugin.svg" alt="Plugins">
        </i>
        <h4 class="head-title">{{ page_title }}</h4>
        <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
            triggers="hover"
            content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
        </b-popover>
        <app-tab :tabs="tabs"></app-tab>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";

export default {
  name: "Plugins",
  components: {
    "app-tab": AppTabs
  },
  data() {
    return {
      tabs: [
        {
          name: "Marketplace",
          href: "/plugins/marketplace",
          access: "plugins.marketplace",
          enabled: true
        },
        {
          name: "Gamification",
          href: "/plugins/gamification",
          access: "plugins.gamification",
          enabled: false
        }
      ],
      page_title: "Plugins"
    }
  }
}
</script>
